import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { HttpService } from '../../http/http-client.service';
import { Financial } from '../../../model/Financial';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class FinancialService {

  constructor(private http: HttpClient, private httpService: HttpService) { }


  requestFinancial(data: Financial) {
    return this.http.post("http://localhost:8080/sdkadiq/requestFinancial", data);
  }

  findAllTransactions() {
    return this.http.get("http://localhost:8080/sdkadiq/findAllTransactions");
  }



}
